<template>
  <div :class="`user with_image ${size}`">
    <div>
      <img
        :src="imageSource"
        alt="avatar"
        class="avatar"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
      required: false.context,
      default: '/assets/images/gmb/user-placeholder.jpg'
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    }
  },
  computed: {
    imageSource() {
      // Occasionally, the prop can be null, despite it being a type of string, and the default value doesnt get used
      if (!this.imageSrc) {
        return '/assets/images/gmb/user-placeholder.jpg';
      }

      return this.imageSrc;
    }
  }
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  position: relative;

  &.xs {
    width: 30px;
    height: 30px;
  }

  &.sm {
    width: 35px;
    height: 35px;
  }

  &.md {
    width: 48px;
    height: 48px;
  }

  &.lg {
    width: 55px;
    height: 55px;
  }

  > div {
    z-index: 1;
    width: 100%;
    height: 100%;
    padding-bottom: 100%;
    position: relative;
    border-radius: 50%;
    background: #8362F9;
  }

  &.with_image {
    > div > img {
      position: absolute;
      width: 100%;
      height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      z-index: 2;
      border-radius: 50%;
      max-width: 100%;
      pointer-events: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 0;
    }
  }
}
</style>
